import { getIntersectionRoot } from '@theme/scroll-container';

class MomentsReveal extends HTMLElement {
  connectedCallback() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const items = this.querySelectorAll('.moments-list__item');
    if (!items.length) return;

    this.classList.add('js-scroll-reveal');

    // Desktop (>=990px) scrolls inside `.page-wrapper`, not the document — the observer's
    // root must match that or intersection never fires correctly (same pattern header.js
    // uses). Without this it defaulted to the viewport, which is wrong on desktop.
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { root: getIntersectionRoot(), threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
    );

    items.forEach((item) => observer.observe(item));
  }
}

if (!customElements.get('moments-reveal')) {
  customElements.define('moments-reveal', MomentsReveal);
}

// Custom mobile slider — plain scroll-snap + arrow buttons, deliberately not the
// theme's shared slideshow component (its base styles were leaking a white
// background into this section's dark theme). querySelectorAll handles multiple
// instances of this section on one page without needing a custom element.
document.querySelectorAll('.moments-list__slideshow-wrap').forEach((wrap) => {
  const scroller = wrap.querySelector('[data-moments-slideshow]');
  const prevBtn = wrap.querySelector('[data-moments-prev]');
  const nextBtn = wrap.querySelector('[data-moments-next]');
  if (!scroller || !prevBtn || !nextBtn) return;

  function scrollByOneSlide(direction) {
    const slide = scroller.querySelector('.moments-list__slide');
    const gap = parseFloat(getComputedStyle(scroller).gap) || 0;
    const distance = slide ? slide.getBoundingClientRect().width + gap : scroller.clientWidth * 0.8;
    scroller.scrollBy({ left: distance * direction, behavior: 'smooth' });
  }

  function updateArrowState() {
    const maxScrollLeft = scroller.scrollWidth - scroller.clientWidth - 1;
    prevBtn.disabled = scroller.scrollLeft <= 0;
    nextBtn.disabled = scroller.scrollLeft >= maxScrollLeft;
  }

  prevBtn.addEventListener('click', () => scrollByOneSlide(-1));
  nextBtn.addEventListener('click', () => scrollByOneSlide(1));
  scroller.addEventListener('scroll', updateArrowState, { passive: true });
  updateArrowState();
});
